import { API_BASE, AUTH_TOKEN } from '../config';

// The world's ASSET REGISTRY — the thing itself, as opposed to the places it
// stands (migration 263, Spec_World_Building_System §1).
//
// Not to be confused with services/assets.js, which signs URLs for the artist's
// MEDIA. These are 3D assets: a mesh with LOD variants, a collider and a
// triangle budget. The two share a word and nothing else, which is why the API
// keeps them on separate routes (/api/world/assets vs /api/assets) and why this
// is a separate file rather than a few more exports over there.
//
// The point of the registry is that many placed objects reference ONE asset, so
// the renderer can group by asset and issue a single instanced draw for all of
// them. Ten subway entrances cost about what one costs.
const hdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${AUTH_TOKEN}` });

/** The library. Small enough to fetch whole and index by id. */
export async function listWorldAssets() {
  try {
    const res = await fetch(`${API_BASE}/api/world/assets`);
    const d = await res.json().catch(() => ({}));
    return d.assets || [];
  } catch { return []; }
}

/**
 * Register or update an asset. UPSERTS on slug, so running it again after
 * rebuilding a model updates the entry in place rather than orphaning every
 * object that points at it.
 */
export async function registerWorldAsset(body) {
  const res = await fetch(`${API_BASE}/api/world/assets`, { method: 'POST', headers: hdr(), body: JSON.stringify(body) });
  const d = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(d.error || `register failed (${res.status})`);
  return d.asset;
}

/** The URL a client should actually load, best tier first. */
export function assetUrlFor(asset) {
  const v = asset?.variants;
  if (!Array.isArray(v) || !v.length) return null;
  const byTier = v.find((x) => x.tier === 'lod0') || v[0];
  return byTier?.url || null;
}
